export const routePaths = {
    blogs: 'blogs',
    blogsSettings: 'blogs/settings/',
    blogsPostEdit: 'blogs/post/:postId/edit',
    blogsPostSettings: 'blogs/post/:postId/settings',
    blogsPostPreview: 'blogs/post/:postId/preview',
    blogsPostVersions: 'blogs/post/:postId/versions',
    blogsInvaliRoutes: {
        blogPost: 'blogs/post',
        blogPostWithId: 'blogs/post/:id',
        blogsAuthors: 'blogs/settings/authors',
        blogsAuthorsEdit: 'blogs/settings/authors/:authorId/edit',
        blogsCategories: 'blogs/settings/categories',
        blogsCategoriesEdit: 'blogs/settings/categories/:categoryId/edit',
    },
    emailServices: 'email_services',
    agencyDedicatedDomains: 'email_services/dedicated-domains',
    agencyAddDomain: 'email_services/dedicated-domains/add-domain',
    agencyVerifyDomain: 'email_services/dedicated-domains/verify-domain',
    smtpServices: 'smtp_service',
    emailServicesDedicatedDomains: 'smtp_service/dedicated-domains',
    emailServicesAddDomain: 'smtp_service/dedicated-domains/add-domain',
    emailServicesVerifyDomain: 'smtp_service/dedicated-domains/verify-domain',
    mobileAppCustomiser: '/mobile-app-customiser'
}
